<template>
  <span class="tree">
    <tree
      class="row-2"
      :data.sync="data"
      :options="opts"
      ref="faultTree"
      @node:checked="true"
    >
      <div slot-scope="{ node }" class="node-container">
        <div class="node-name">{{ node.text }}</div>
        <div class="node-controls" v-if="editable">
          <b-icon
            class="btn-icon node"
            :title="$t('adicionar-no')"
            @click.stop="addChildNode(node)"
            icon="node-plus-fill"
          ></b-icon>
          <b-icon
            v-if="!node.states.disable"
            class="btn-icon node"
            :title="$t('excluir-no')"
            @click.stop="removeNode(node)"
            icon="node-minus-fill"
          ></b-icon>
          <b-icon
            class="btn-icon"
            :title="$t('editar-no')"
            @click.stop="editNode(node)"
            icon="pencil-fill"
          ></b-icon>
        </div>
      </div>
    </tree>
    <MessageBox
      class="msgBoxDecision"
      style="display: none"
      :header="$t('atencao')"
      info=""
      :question="question"
      :cancelAction="close"
      v-bind:action="deleteNode"
    />
  </span>
</template>
<script>
import { defaultSuccess } from "@/global";
import tree from "liquor-tree";
import MessageBox from "@/components/template/MessageBox";

export default {
  name: "DecisionTree",

  components: { tree, MessageBox },

  props: {
    editable: {
      typeof: Boolean,
      required: true,
    },
    data: {
      required: true,
    },
    optCheckBox: {
      type: Boolean,
      required: false,
      default: false,
    },
    getTree: {
      type: Number,
      required: true,
    },
    updateTree: {
      type: Object,
    },
    nodeDbClick: {
      type: Object,
    },
    refresh: {
      type: Number,
    },
  },

  computed: {
    question: function () {
      if (this.transientNode.data) {
        return this.$t('tem-certeza-que-deseja-apagar-o-no-this-transientnode-data-text', [this.transientNode.data.text]) ;
      }
      return "";
    },
  },

  data() {
    return {
      opts: {
        checkbox: this.optCheckBox,
        dnd: this.editable,
        selectedNode: "",
      },
      transientNode: {},
    };
  },

  watch: {
    getTree() {
      this.$emit("updateTree", this.$refs.faultTree.tree.model);
    },

    refresh() {
      let tree = this.$refs.faultTree.tree.model;
      if (tree.length > 0) {
        tree.forEach((n) =>
          this.$refs.faultTree.tree.remove({ text: n.data.text }, true)
        );
      }
    },
  },

  methods: {
    addChildNode(node) {
      if (node.enabled()) {
        node.append(this.$t('nova-acao'));
        node.children[node.children.length - 1].data.type = "reason";
        defaultSuccess(this.$t('acao-adicionado'));
      }
    },

    editNode(node) {
      node.startEditing();
    },

    removeNode(node) {
      console.log('node :>> ', node);
      if (!node.states.disable && this.confirmDelete())
        this.transientNode = node;
    },

    confirmDelete() {
      this.openMessage();
      return true;
    },

    deleteNode() {
      this.transientNode.remove();
      this.close();
      this.$emit("updateTree", this.$refs.faultTree.tree.model);
    },

    close() {
      document.querySelector(".msgBoxDecision").style.display = "none";
    },

    openMessage() {
      document.querySelector(".msgBoxDecision").style.display = "flex";
    },

    async builderNodes(tree, node) {
      let newNode = null;

      for (let i = 0; i < tree.length; i++) {
        let n = tree[i];
        let found = await this.findNode(n, node.id);
        if (found) {
          let children = await this.builderNodes(n.children, node);
          newNode = {
            index: i,
            id: n.id,
            text: n.data.text,
            children: children,
          };
          break;
        }
      }
      return newNode;
    },

    async findNode(tree, id) {
      if (tree.id == id) {
        return true;
      }

      if (!tree.children) return false;

      let result = false;
      for (let i = 0; i < tree.children.length; i++) {
        let n = tree.children[i];
        if (n.id == id || (await this.findNode(n, id))) {
          result = true;
          break;
        }
      }
      return result;
    },

    formatNodes(node) {
      let path = node.text;
      if (node.children) {
        path +=  this.$t('greater-than-this-formatnodes-node-children', [this.formatNodes(node.children)]) ;
      }
      return path;
    },
  },
};
</script>

<style>
.tree-node.selected {
  border: none;
}
</style>

<style scoped>
.tree {
  display: flex;
  flex-direction: column;
}

.btn-controls {
  color: #0099;
  text-decoration: black;
  margin: 0 0 0 10px;
}

.btn-controls::first-line {
  margin: 0 0 0 5px;
}

.btn-icon {
  margin-right: 12px;
  font-size: 0.95rem;
  align-self: center;
}

.btn-icon.node {
  font-size: 1.3rem;
}

.btn-controls:hover {
  color: #000;
}

.msgBoxDecision {
  top: calc(50% - 210px);
  transition-duration: 1s;
}

.row-2 {
  height: inherit;
}
</style>